import { FieldMessages } from '@/modules/field/field.messages';
import { MapMessages } from '@/modules/Map/map.messages';
import { OrthMessages } from '@/modules/orth/orth.messages';
import { SubscriptionMessages } from '@/modules/subscription/subscription.messages';
import { MessageBus } from '@ayditeam1/aydi-message-bus';

//*  Dead Events  */
/*
no emitters:
  add:polygon
  shape:removed
  api:auth:error
  'reset:plotsPanel': undefined;
  'update:socket': undefined;
 no listeners:
  'record-audio': void;
  EmptyFields: void;
*/

type SharedMessages = {
  'thread:access:denied': undefined;
  /** Expand the map weather overlay to show full forecast (e.g. from Spray Window notification). */
  'weather:openFull': undefined;
};

type Messages = SharedMessages &
  FieldMessages &
  MapMessages &
  OrthMessages &
  SubscriptionMessages;

const messageBus = new MessageBus<Messages>('in-memory', {
  debug: process.env.NODE_ENV !== 'production',
});

export { messageBus };
